module.exports = __webpack_public_path__ + "img/donate.8031a2dc.svg";